import request from '../utils/fetch'
import { stringify } from 'qs'

const ENTRY = '/devices-types'

export const getDeviceTypeByDeviceIds = ids => {
  const query = {
    _id: {
      $in: ids
    }
  }
  const queryString = stringify(query)
  return request(ENTRY + `?${queryString}`, {
    method: 'GET'
  })
}
